export default __webpack_public_path__ + "static/media/logo.786d6baf.png";